import script from "./StatusMetricWidgetConfig.vue?vue&type=script&lang=js"
export * from "./StatusMetricWidgetConfig.vue?vue&type=script&lang=js"

import "./StatusMetricWidgetConfig.vue?vue&type=style&index=0&id=2bd5320d&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2bd5320d"],['__file',"src/containers/widget/configs/StatusMetricWidgetConfig.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2bd5320d"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2bd5320d', __exports__)) {
    api.reload('2bd5320d', __exports__)
  }
  
}


export default __exports__